module.exports = {"name":"PipelineProcessor","version":"2.4.7","description":"","repository":{"type":"git","url":"graylog-plugin-pipeline-processor"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Graylog, Inc. <hello@graylog.com>","license":"GPL-3.0","dependencies":{"brace":"^0.7.0","react-ace":"^3.1.0"},"devDependencies":{"graylog-web-plugin":"file:../../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 208
// module chunks = 0